import Router from 'next/router';
import { v4 as uuid } from 'uuid';

import type { State } from '@framework/appInsights';
import { APPLICATION_SECTIONS, ATTENDEE_SECTIONS } from '@framework/constants/enums';
import { decamelizeKeys } from '@framework/utils/camelize.utils';

/**
 * Key used to identify current session ( used to identify events coming from the same tab )
 */
export const appInsightsSessionKey = uuid();

export const getInsightPayload = (state?: State, data = {}) => {
    if (!state) {
        return decamelizeKeys({
            stack: 'react',
            url: window.location.href,
            appSessionId: appInsightsSessionKey
        });
    }
    const router = Router;
    const { currentAppSection, isAttendeeView } = state;
    const attendeeMeeting =
        currentAppSection === ATTENDEE_SECTIONS.MEETING_DETAILS && String(router.query.uuid);
    const editorMeeting =
        currentAppSection === APPLICATION_SECTIONS.MEETING_DETAILS &&
        String(router.query.slug?.[0]);

    return decamelizeKeys({
        stack: 'react',
        appSessionId: appInsightsSessionKey,
        eventId: attendeeMeeting || editorMeeting,
        view: isAttendeeView ? 'member' : 'secretary',
        ...data
    });
};

export const getURLWithMaskedRoomName = () => {
    if (typeof window === 'undefined') {
        return '';
    }
    const matchResult = window?.location.pathname.match(/\/rooms\/([^/]+)\//);
    const roomName = matchResult?.[1] ?? '';

    return window.location.href.replace(roomName, 'room');
};
